import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import {
  ParagraphClaim,
  ParagraphCollectionComponent,
  ParagraphLayout,
  ParagraphMediaGallery,
  ParagraphText,
} from '@madeinlune/massaud-types';
import { ParagraphSwitcherDirective } from '@madeinlune/paragraphs';

@Component({
  selector: 'mil-paragraphs',
  standalone: true,
  imports: [NgForOf, NgIf, ParagraphSwitcherDirective],
  template: `
    <ng-container *ngIf="paragraphs">
      <ng-template ngFor [ngForOf]="paragraphs" let-paragraph>
        <div class="root-paragraph">
          <ng-template *milParagraphSwitcher="paragraph"></ng-template>
        </div>
      </ng-template>
    </ng-container>
  `,
  styleUrls: ['./paragraphs.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ParagraphsComponent implements ParagraphCollectionComponent {
  @Input()
  paragraphs:
    | (
        | ParagraphText
        | ParagraphLayout
        | ParagraphMediaGallery
        | ParagraphClaim
      )[]
    | undefined;
}
